import {memo} from "react";

const ScriptBlock = memo(({ node }: any) => {
    const scriptContent = node.children[0]?.value || ''
    return `<script>${scriptContent}</script>`;
});
ScriptBlock.displayName = 'ScriptBlock';
export default ScriptBlock;
